function TrialSite({
  id,
  trialId,
  name,
  email,
  address,
  phone,
  distance,
  location,
  eligibility,
  status,
  primaryInvestigator,
  distanceUnit,
  siteIcon,
  investigatorName,
  investigatorAvatar,
}) {
  const self = this;

  self.id = id;
  self.trialId = trialId;
  self.name = name;
  self.address = address;
  self.phone = phone;
  self.email = email;
  self.distance = distance;
  self.location = location;
  self.eligibility = eligibility;
  self.status = status;
  self.primaryInvestigator = primaryInvestigator;
  self.distanceUnit = distanceUnit;
  self.siteIcon = siteIcon;
  self.investigatorName = investigatorName;
  self.investigatorAvatar = investigatorAvatar;

  self.getSitePhoneLink = function () {
    return `tel:${self.phone}`;
  };

  self.getSiteMailLink = function () {
    return `mailto:${self.email}`;
  };
}

export default TrialSite;
